import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import authService from '../api-authorization/AuthorizeService';
import { ApplicationPaths } from '../api-authorization/ApiAuthorizationConstants';
import { Box, Button, TextField, Checkbox, FormControlLabel, Typography, Paper, Alert, Link as MuiLink } from '@mui/material';

const LoginFormComponent: React.FC = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    const [rememberMe, setRememberMe] = useState<boolean>(false);
    const [message, setMessage] = useState<string | null>(null);

    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
        setMessage(null);

        try {
            const params = new URLSearchParams(window.location.search);
            const urlReturnUrl = params.get('returnUrl');

            const result = await authService.loginWithCredentials(email, password, rememberMe, '/');

            if (result.status === 'success') {
                if (urlReturnUrl && urlReturnUrl !== '/' && !urlReturnUrl.startsWith(ApplicationPaths.ApiAuthorizationPrefix)) {
                    navigate(urlReturnUrl, { replace: true });
                    return;
                }
                navigate('/', { replace: true });
            } else {
                setMessage(result.message || 'Login failed.');
            }
        } catch (error: any) {
            setMessage(error.message || 'An unexpected error occurred during login.');
        }
    };

    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', my: 5 }}>
            <Paper elevation={6} sx={{ p: 4, width: '100%', maxWidth: 400 }}>
                <Typography variant="h4" component="h2" align="center" gutterBottom>
                    Вход
                </Typography>
                <Box component="form" onSubmit={handleSubmit} noValidate>
                    {message && <Alert severity="error" sx={{ mb: 2 }}>{message}</Alert>}
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        id="email"
                        label="Электронная почта"
                        name="email"
                        autoComplete="email"
                        autoFocus
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label="Пароль"
                        type="password"
                        id="password"
                        autoComplete="current-password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <FormControlLabel
                        control={<Checkbox value="remember" color="primary" checked={rememberMe} onChange={(e) => setRememberMe(e.target.checked)} />}
                        label="Запомнить меня"
                    />
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{ mt: 3, mb: 2 }}
                    >
                        Войти
                    </Button>
                    <Box sx={{ textAlign: 'center' }}>
                        <MuiLink href={`/${ApplicationPaths.IdentityRegisterPath}`} variant="body2">
                            Зарегистрироваться
                        </MuiLink>
                    </Box>
                </Box>
            </Paper>
        </Box>
    );
};

export default LoginFormComponent;
